
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import MissionSection from "@/components/about/MissionSection";
import TimelineSection from "@/components/about/TimelineSection";
import MetricsSection from "@/components/about/MetricsSection";
import BenefitsSection from "@/components/about/BenefitsSection";
import SEO from "@/components/SEO";
import useAnalytics from "@/hooks/use-analytics";
import { useEffect } from "react";

const Sobre = () => {
  const { trackPageView } = useAnalytics();

  // Track page view
  useEffect(() => {
    trackPageView("sobre", "company_page");
  }, [trackPageView]);

  // Organization schema for SEO
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Dr.Cash",
    "url": "https://drcash.com.br",
    "logo": "https://drcash.com.br/lovable-uploads/adbefe14-3b0b-4fb7-9d68-80ff26cf5191.png",
    "description": "Dr.Cash é uma fintech especializada em soluções de financiamento para o setor de saúde, oferecendo boleto parcelado e antecipação de recebíveis.",
    "foundingDate": "2018",
    "founder": {
      "@type": "Person",
      "name": "Fundadores Dr.Cash"
    },
    "sameAs": [
      "https://www.facebook.com/drcash.com.br/",
      "https://www.instagram.com/drcashbr",
      "https://br.linkedin.com/company/drcashbr"
    ]
  };

  return (
    <>
      <SEO
        title="Sobre a Dr.Cash | Nossa História e Missão | Financiamento para Saúde"
        description="Conheça a história da Dr.Cash, fintech especializada em soluções financeiras para a área da saúde. Desde 2018 ajudamos clínicas a melhorar seu fluxo de caixa."
        keywords="história drcash, sobre drcash, fintech saúde, financiamento médico, quem somos drcash"
        canonical="/sobre"
        structuredData={organizationSchema}
      />
      <Navbar />
      <main className="pt-4">
        <TimelineSection />
        {/* VideoSection is part of MissionSection component */}
        <BenefitsSection />
        <MissionSection />
        <MetricsSection />
      </main>
      <Footer />
    </>
  );
};

export default Sobre;
